import { render } from "./DashboardDropdownList.vue?vue&type=template&id=4a2c2c11&scoped=true"
import script from "./DashboardDropdownList.vue?vue&type=script&lang=ts"
export * from "./DashboardDropdownList.vue?vue&type=script&lang=ts"

import "./DashboardDropdownList.vue?vue&type=style&index=0&id=4a2c2c11&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a2c2c11"

export default script